// store.ts
import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';

import loginReducer from './redux/loginSlice';
import contactSlice from './redux/contactsSlice';
import basicReport from './redux/basicReport';
import global from './redux/global';
import tdlibSlice from './redux/tdlibSlice';
import notiSlice from './redux/notiSlice';
import TongHopSlice from './redux/TongHopSlice';
import wsSlice from './redux/wsSlice';
import  pushNotificationSlice  from './redux/notificationsSlice';

// Gộp reducer như cũ
const rootReducer = combineReducers({
  login: loginReducer,
  contact: contactSlice,
  basicReport: basicReport,
  global: global,
  tdlibSlice: tdlibSlice,
  notiSlice: notiSlice,
  tongHopSlice: TongHopSlice,
  wsSlice: wsSlice,
  pushNotification: pushNotificationSlice,
});

// Tạo store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// ====== TYPES CHUẨN CHO TS ======

// Toàn bộ state của app
export type RootState = ReturnType<typeof store.getState>;

// Kiểu dispatch
export type AppDispatch = typeof store.dispatch;

// Nếu sau này bạn muốn viết thunk có type riêng:
// export type AppThunk<ReturnType = void> =
//   ThunkAction<ReturnType, RootState, unknown, AnyAction>;

// thunk action to do global logout
export const logout = () => (dispatch: AppDispatch) => {
  // TODO: viết logic logout ở đây

};

// Default export cho code cũ vẫn dùng được
export default store;